export const GLOBAL_STATE = 'StudentDashboard'

export const DASHBOARD_STUDENT = 'student'
